// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "e7f628f9a12aa5e5","396": "84e849e4e56cda47","460": "bfb6322db99519dc","498": "154837983f4d9dda","917": "31a9d5773f2425f4","985": "67ffd2d84573a4fa",}[chunkId] + ".chunk.js"
}